import { get } from 'lodash';
import React from 'react';
import { Link } from 'react-router-dom';

import { INTERNAL_LINKS } from '../../../enum';
import { momentTimezone } from '../../../utils/common';
import Button from '../../Button';
import ProfileNamePicture from '../../shared-ui/ProfileNamePicture';
import CustomTable from '../../Table';
import Text from '../../Text';
import LinkText from '../../Text/LinkText';

const RateQuotesTable = props => {
  const {
    t,
    dataSource,
    loading,
    onDeleteRateClick,
    onSearchTermChange,
    defaultSearchTerm,
    ...rest
  } = props;

  const COLUMNS = [
    {
      sorter: true,
      key: 'company',
      title: t('Company'),
      dataIndex: ['company', 'name'],
      render: (companyName, record) => {
        if (!companyName) return '-';

        return (
          <Link to={`${INTERNAL_LINKS.SELECT_COMPANY}/${record.company._id}`}>
            <LinkText variant="strong">{companyName}</LinkText>
          </Link>
        );
      },
    },
    {
      sorter: true,
      width: 200,
      key: ['user.firstName', 'user.lastName'].join(','),
      title: t('User'),
      render: (_, record) => {
        return record.user ? (
          <ProfileNamePicture t={t} user={record.user} showAvatar={false} showStatus={false} />
        ) : (
          <Text
            size="sm"
            style={{
              maxWidth: '200px',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {record.email}
          </Text>
        );
      },
    },
    {
      sorter: true,
      align: 'right',
      key: 'variableRate',
      title: t('variableRate'),
      dataIndex: 'variableRate',
    },
    {
      sorter: true,
      align: 'right',
      key: 'fixedRate',
      title: t('fixedRate'),
      dataIndex: 'fixedRate',
    },
    {
      sorter: true,
      key: 'createdBy',
      title: t('createdBy'),
      render: (_, record) => {
        const createdBy = get(record, 'createdBy');
        if (createdBy) {
          return `${createdBy.firstName} ${createdBy.lastName}`;
        }
        return '-';
      },
    },
    {
      sorter: true,
      defaultSortOrder: 'descend',
      key: 'created',
      title: t('creationDate'),
      dataIndex: 'created',
      render: date => (
        <Text size="sm" style={{ whiteSpace: 'pre' }}>
          {momentTimezone(date).format('LL [\n]hh:mm a zz')}
        </Text>
      ),
    },
    {
      key: 'actions',
      title: '',
      render: (_, data) => (
        <Button type="secondary" size="xs" onClick={() => onDeleteRateClick(data._id)}>
          {t('Delete')}
        </Button>
      ),
    },
  ];

  return (
    <CustomTable
      {...rest}
      rowKey={data => data._id}
      scroll={{ x: 900 }}
      columns={COLUMNS}
      dataSource={dataSource}
      loading={loading}
      onSearchTermChange={onSearchTermChange}
      defaultSearchTerm={defaultSearchTerm}
    />
  );
};

export default RateQuotesTable;
